import {
  address,
  company,
  internet,
  lorem,
  phone,
  random,
} from "faker/locale/en_US";

import { randomDate } from "./utils";
import { defaultCompanySectors } from "../../../root/defaultConfiguration";
import type { Company, RAFile } from "../../../types";
import type { Db } from "./types";

const sizes = [1, 10, 50, 250, 500];

const regex = /\W+/;

const testCompanies = [
  {
    name: "TechSolutions BPO Financeiro Ltda",
    sector: "servicos",
    size: 50 as const,
    website: "https://techsolutions.com.br",
    city: "São Paulo",
    state_abbr: "SP",
    phone_number: "(11) 98765-4321",
    description:
      "Empresa de tecnologia focada em soluções BPO financeiro e contábil.",
  },
  {
    name: "Mercado Central de Alimentos Ltda",
    sector: "comercio",
    size: 10 as const,
    website: "https://mercadocentral.com.br",
    city: "Belo Horizonte",
    state_abbr: "MG",
    phone_number: "(31) 98888-1234",
    description: "Distribuidora e comércio varejista de alimentos com 3 lojas.",
  },
  {
    name: "Construtora Silva & Filhos Engenharia",
    sector: "construcao-civil",
    size: 250 as const,
    website: "https://silvafilhoscivil.com.br",
    city: "Curitiba",
    state_abbr: "PR",
    phone_number: "(41) 97777-5678",
    description:
      "Construtora e incorporadora especializada em obras residenciais.",
  },
];

export const generateCompanies = (_db: Db, size = 3): Required<Company>[] => {
  return Array.from(Array(size).keys()).map((id) => {
    const predefined = testCompanies[id % testCompanies.length];
    const name = predefined?.name || company.companyName();
    return {
      id,
      name: name,
      logo: {
        title: lorem.text(1),
        src: `https://marmelab.com/react-admin-crm/logos/${id}.png`,
      } as RAFile,
      sector:
        predefined?.sector || random.arrayElement(defaultCompanySectors).value,
      size:
        predefined?.size ||
        (random.arrayElement(sizes) as 1 | 10 | 50 | 250 | 500),
      linkedin_url: `https://www.linkedin.com/company/${name
        .toLowerCase()
        .replace(regex, "_")}`,
      website: predefined?.website || internet.url(),
      phone_number: predefined?.phone_number || phone.phoneNumber(),
      address: address.streetAddress(),
      zipcode: address.zipCode(),
      city: predefined?.city || address.city(),
      state_abbr: predefined?.state_abbr || address.stateAbbr(),
      nb_contacts: 0,
      nb_deals: 0,
      sales_id: 0,
      created_at: randomDate().toISOString(),
      description: predefined?.description || lorem.paragraph(),
      revenue: random.arrayElement(["$1M", "$10M", "$100M", "$1B"]),
      tax_identifier: random.alphaNumeric(10),
      country: "Brasil",
      context_links: [],
    };
  });
};
